import { render } from "./AddActivityForm.vue?vue&type=template&id=2cc6ff44"
import script from "./AddActivityForm.vue?vue&type=script&lang=js"
export * from "./AddActivityForm.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__